import './samplesListTableComponent.scss'
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {ISample} from "../../../shared/models/sample.model";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import {Link} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import CheckboxComponent from "../../../shared/components/core/checkbox/CheckboxComponent";
import _ from "lodash";
import {ITableColumn} from "../../../shared/models/table.model";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PdfPreviewComponent from "../../../shared/components/pdf-preview/pdfPreviewComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import DialogComponent from "../../../shared/components/dialog/dialogComponent";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {APIConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import commonService from "../../../shared/services/common.service";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {useNavigate} from "react-router-dom";

interface SamplesListTableComponentProps {
    filterData: any
    selectedSamples: ISample[];
    onSampleSelectUpdate: (sampleList: ISample[]) => void;
}

const MODULE_NAME = "sampleList";
const SamplesListTableComponent = (props: SamplesListTableComponentProps) => {

        const hiddenFileInput = React.useRef<any>(null);
        const {filterData, selectedSamples, onSampleSelectUpdate} = props;
        const [data, setData] = useState<any>(undefined);
        const sendOutApplicableSamples = data?.filter((sample: ISample) => sample.status === "accessioned");
        const [isSelectAll, setIsSelectAll] = useState<boolean>(false);
        const [isIndeterminate, setIsIndeterminate] = useState<boolean>(false);
        const [isNewResultPdf, setNewResultPdf] = useState<boolean>(false)
        const [isContinueVisible, setIsContinueVisible] = useState<boolean>(false);
        const [resultUploadPdf, setResultUploadPdf] = useState<any>(undefined);
        const [showResultPdfPreviewDialog, setShowResultPdfPreviewDialog] = useState<boolean>(false);
        const [selectedSampleList, setSelectedSampleList] = useState<ISample[]>([]);
        const [isResultPdfBeingUploaded, setIsResultPdfBeingUploaded] = useState<boolean>(false);
        const [sampleID, setSampleID] = useState<number | undefined>(undefined);
        const [orderID, setOrderID] = useState<number | undefined>(undefined);
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);
        const navigate = useNavigate();

        const handleSelectDeselectAllSamples = useCallback((isChecked: boolean) => {
            const updatedSampleList = _.cloneDeep(selectedSampleList);
            if (isChecked) {
                sendOutApplicableSamples?.forEach((item: any) => {
                    const sampleID = item.id;
                    const index = updatedSampleList.findIndex(item => item.id === sampleID);
                    if (index === -1) {
                        updatedSampleList.push(item);
                    }
                })
            } else {
                sendOutApplicableSamples?.forEach((item: any) => {
                    const sampleID = item.id;
                    const index = updatedSampleList.findIndex(item => item.id === sampleID);
                    if (index > -1) {
                        updatedSampleList.splice(index, 1);
                    }
                })
            }
            setSelectedSampleList(updatedSampleList);
            onSampleSelectUpdate(updatedSampleList);
        }, [sendOutApplicableSamples, onSampleSelectUpdate, selectedSampleList]);

        const handleSelectDeselectSample = useCallback((isChecked: boolean, sample: ISample) => {
            const updatedSampleList = _.cloneDeep(selectedSampleList);
            if (isChecked) {
                updatedSampleList.push(sample);
            } else {
                const sampleID = sample.id;
                updatedSampleList.splice(updatedSampleList.findIndex(item => item.id === sampleID), 1);
            }
            setSelectedSampleList(updatedSampleList);
            onSampleSelectUpdate(updatedSampleList);
        }, [onSampleSelectUpdate, selectedSampleList]);

        useEffect(() => {
            if (selectedSampleList?.length > 0) {
                if (sendOutApplicableSamples?.map((item: any) => item.id).every((sampleID: any) => selectedSampleList.map((item) => item.id).includes(sampleID))) {
                    setIsSelectAll(true);
                    setIsIndeterminate(false);
                } else {
                    if (sendOutApplicableSamples?.map((item: any) => item.id).some((sampleID: any) => selectedSampleList.map((item) => item.id).includes(sampleID))) {
                        setIsIndeterminate(true);
                    } else {
                        setIsSelectAll(false);
                    }
                }
            } else {
                setIsSelectAll(false);
                setIsIndeterminate(false);
            }
        }, [selectedSampleList, sendOutApplicableSamples]);


        const handleResultPdfUpload = useCallback((event: any) => {
            const file = event?.target?.files[0];
            const maxAllowedSize = 5 * 1024 * 1024;
            if (event?.target?.files[0].size > maxAllowedSize) {
                CommonService._alert.showToast('File size should be under 5MB.', "error");
                event.target.value = null;
                event.target.files = null;
                return;
            }
            event.target.value = null;
            event.target.files = null;
            setIsContinueVisible(true);
            setShowResultPdfPreviewDialog(true);
            setResultUploadPdf(file);
            setNewResultPdf(true);
            // resultUploadPdfRef.current.

        }, []);

        const columns: ITableColumn[] = useMemo<any>(() => [
            {
                id: 'select',
                label: <> {
                    commonService.checkAccess('TestOrderSample',
                        'sampleSendOut', currentUser?.userAccessModules) &&
                    <CheckboxComponent
                        name={"sample_select_all"}
                        size={"small"}
                        disableRipple={true}
                        checked={isSelectAll}
                        indeterminate={isIndeterminate}
                        onUpdate={handleSelectDeselectAllSamples}
                    />
                } </>,
                hideInColumnPreferences: true,
                isDefaultColumn: true,
                fixed: "left",
                width: '50',
                content: (item: ISample) => (
                    <>
                        {
                            commonService.checkAccess('TestOrderSample',
                                'sampleSendOut', currentUser?.userAccessModules) &&
                            <CheckboxComponent
                                name={"sample_select"}
                                size={"small"}
                                disabled={sendOutApplicableSamples?.findIndex((sample: ISample) => sample.id === item.id) === -1}
                                disableRipple={true}
                                checked={selectedSampleList.findIndex((sample: ISample) => sample.id === item.id) > -1}
                                onUpdate={(isChecked: boolean) => {
                                    handleSelectDeselectSample(isChecked, item);
                                }}/>
                        }
                    </>
                )
            },
            {id: 'barcode', label: 'Accession ID', isDefaultColumn: true, fixed: "left", align: "center"},
            {
                id: 'labBarcode', label: 'Re-assigned ID', isDefaultColumn: true, align: "center",
                content: (item: ISample) => (
                    <>
                        {
                            item ? <>{item?.labBarcode && (item?.barcode !== item?.labBarcode) ? item?.labBarcode : '-'} </> : <> - </>
                        }
                    </>
                )
            },
            {
                id: 'collectionDateAndTime',
                label: 'Collection Date & Time',
                align: "center",
                isDefaultColumn: true,
                width: "200",
                sortable: true,
                content: (item: ISample) => (
                    <>
                        {
                            item ? <>{item?.dateOfCollection ? item?.dateOfCollection : '-'}  &nbsp;|&nbsp; {item?.timeOfCollection ? item?.timeOfCollection.slice(0, 5) : '-'}</> : <> - </>
                        }
                    </>
                )
            },
            {
                id: 'sampleType', label: 'Sample Type', isDefaultColumn: false, sortable: false, align: "center",
                content: (item: ISample) => (
                    <>
                        {
                            item ? <>{item?.sampleType ? CommonService.capitalizeFirstLetterOfEachWord(item?.sampleType) : '-'}</> : <> - </>
                        }
                    </>
                )
            },
            {
                id: 'testCode',
                label: 'Test Code',
                isDefaultColumn: true,
                sortable: false,
                align: "center",
                content: (item: ISample) => {
                    return <>
                        {
                            item.testDetails ? (CommonService.capitalize(item.testDetails.code)?.length > 10 ?
                                <TooltipComponent
                                    tooltip={
                                        <div className={'pdd-right-15 pdd-top-5 pdd-bottom-5'}>
                                            {CommonService.capitalize(item.testDetails.code)}
                                        </div>}
                                    arrow={true}>
                                    <div className={'ellipses-for-table-data-panels'}>
                                        {CommonService.capitalize(item.testDetails.code)}
                                    </div>
                                </TooltipComponent>
                                : CommonService.capitalize(item.testDetails.code)) : '-'
                        }
                    </>
                }
            },
            {
                id: 'patient', label: 'Patient',
                isDefaultColumn: true, width: '200',
                content: (item: ISample) => (
                    <>
                        {
                            item?.orderDetails?.patientDetails ? <>
                                {
                                    (item?.orderDetails?.orderDetails?.patientDetails?.firstName + ' ' + item?.orderDetails?.patientDetails?.lastName)?.length > 30 ?
                                        <TooltipComponent
                                            tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.firstName) + " " + CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.lastName)}
                                            placement={"top"}
                                            arrow={true}
                                        >
                                            <>
                                                <div className={"ellipses-for-table-data"}>
                                                    {CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.firstName)} {CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.lastName)}
                                                </div>
                                            </>
                                        </TooltipComponent> :
                                        <>
                                            {CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.firstName)} {CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.lastName)}
                                        </>
                                }
                                <br/>
                                {
                                    item?.orderDetails?.patientDetails?.gender && <>
                                        (&nbsp;{item?.orderDetails?.patientDetails?.gender[0]?.toUpperCase()}&nbsp;)&nbsp;
                                    </>
                                }
                                {commonService.formatDate(item?.orderDetails?.patientDetails.dateOfBirth)}
                            </> : <> - </>
                        }
                    </>
                )
            },

            {
                id: 'isEnbVerified', label: 'EnB', isDefaultColumn: true, align: "center", width: '80',
                content: (item: any) => (
                    // (item?.insuranceDetails?.isEnbotChecked === true || item?.insuranceDetails?.isEnbotChecked === false) ?
                    //     <>
                    //         {
                    //             item?.insuranceDetails?.isEnbotChecked ?
                    //                 <TooltipComponent
                    //                     tooltip={"EnB Verified"}
                    //                     placement={"right"}
                    //                     arrow={true}
                    //                 >
                    //                     <CheckCircleIcon/>
                    //                 </TooltipComponent> :
                    //                 <TooltipComponent
                    //                     tooltip={"EnB Not Verified"}
                    //                     placement={"right"}
                    //                     arrow={true}
                    //                 >
                    //                     <CancelIcon/>
                    //                 </TooltipComponent>
                    //         }
                    //     </> :
                    //     <>-</>
                    "-"
                )

            },
            {
                id: 'isConsentSigned', label: 'Consent', isDefaultColumn: true, align: "center", width: '80',
                content: (item: ISample) => (
                    (item?.billingMode !== 'insurance') ?
                        <>-</> :
                        <>
                            {
                                item?.isConsentSigned ?
                                    <TooltipComponent
                                        tooltip={"Consent Form Available"}
                                        placement={"right"}
                                        arrow={true}
                                    >
                                        <CheckCircleIcon/>
                                    </TooltipComponent> :
                                    <TooltipComponent
                                        tooltip={"Consent Form Not Available"}
                                        placement={"right"}
                                        arrow={true}
                                    ><CancelIcon/>
                                    </TooltipComponent>
                            }
                        </>
                )

            },

            {
                id: 'billingMode',
                label: 'Billing Mode',
                align: "center",
                isDefaultColumn: false,
                sortable: false,
                content: (item: ISample) => (
                    <>
                        {
                            item ? <>{item?.billingMode ? CommonService.capitalizeFirstLetterOfEachWord(item?.billingMode) : '-'}</> : <> - </>
                        }
                    </>
                )
            },
            {
                id: 'processingLab',
                label: 'Processing Lab',
                align: "center",
                isDefaultColumn: true,
                sortable: false,
                content: (item: ISample) => (
                    <>
                        {
                            item ? <>{item?.accessionedLabDetails ? CommonService.capitalizeFirstLetterOfEachWord(item?.accessionedLabDetails?.name) : '-'}</> : <> - </>
                        }
                    </>
                )
            },
            {
                id: 'status', label: 'Sample Status', isDefaultColumn: true,
                align: "center", width: '150',
                content: (item: ISample) => (
                    <ChipComponent className={`min-width-90 ${item?.status?.replace(' ', '')}`}
                                   label={CommonService.capitalizeFirstLetter(item?.status)}
                                   variant={'outlined'}/>
                )
            },
            {
                id: 'activityLog',
                label: 'Activity',
                isDefaultColumn: true,
                sortable: false,
                fixed:'right',
                align: "center",
                content: (item: ISample) => (
                    <ButtonComponent
                        type="button"
                        color={"secondary"}
                        variant={"outlined"}
                        className={'view-activity-log-button'}
                        fullWidth={false}
                        startIcon={
                            <VisibilityIcon/>}
                        handleClick={() => {
                            navigate(commonService._routeConfig.TestSampleActivityLogsRoute(item?.orderId, item?.id,'sampleList'))
                        }}
                        size={'small'}
                    >
                        Activity
                        Log
                    </ButtonComponent>
                )

            },
            {
                id: 'pdf', label: 'Result', isDefaultColumn: true,
                align: 'center',
                fixed: "right",
                width: "170",
                content: (item: ISample) => (
                    <>
                        {
                            item?.status !== 'Report Excluded' ?
                                item?.pdfDetails?.url ?
                                    <a href={item?.pdfDetails?.url}
                                       target="_blank" rel="noreferrer"
                                    >
                                        <PictureAsPdfIcon/>
                                    </a> : <>
                                        {(item?.statusObj?.code !== 'rejected') && (commonService.checkAccess('TestOrderSample', 'sampleSendOut', currentUser?.userAccessModules)) ? <>
                                                <ButtonComponent
                                                    color={"primary"}
                                                    variant={"outlined"}
                                                    fullWidth={false}
                                                    size={'small'}
                                                    disabled={item?.statusObj?.code === 'pending'}
                                                    startIcon={<FileUploadIcon/>}
                                                    handleClick={() => {
                                                        setSampleID(item.id);
                                                        setOrderID(item.orderId);
                                                        hiddenFileInput?.current?.click();
                                                    }}>
                                                    Upload
                                                </ButtonComponent>
                                            </>
                                            : '-'
                                        }
                                    </> :
                                <>-</>
                        }
                    </>
                )
            }
        ], [currentUser, selectedSampleList, sendOutApplicableSamples, setSampleID, setOrderID, handleSelectDeselectAllSamples, handleSelectDeselectSample, isIndeterminate, isSelectAll,navigate]);

        useEffect(() => {
            setSelectedSampleList(selectedSamples);
        }, [selectedSamples]);

        const handleSamplePdfUploadSuccess = useCallback((response: any) => {
            CommonService._communications.TableWrapperRefreshSubject.next({
                moduleName: MODULE_NAME
            });
            setIsResultPdfBeingUploaded(false);
            setResultUploadPdf(undefined);
        }, []);

        const onUploadResultPdf = useCallback(() => {
            const formData = new FormData();
            if (resultUploadPdf) {
                formData.append('file', resultUploadPdf);
            }
            setIsResultPdfBeingUploaded(true);
            CommonService._lab.uploadSamplePdf(sampleID, orderID, formData)
                .then((response: IAPIResponseType<any>) => {
                    handleSamplePdfUploadSuccess(response);
                    setShowResultPdfPreviewDialog(false);
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error uploading Result Pdf', "error");
                    setIsResultPdfBeingUploaded(false);
                })
        }, [orderID, resultUploadPdf, handleSamplePdfUploadSuccess, sampleID]);

        return (
            <>
                <div className="table-list-container">
                    <TableWrapperV2Component
                        isPaginated={true}
                        columns={columns}
                        url={APIConfig.SAMPLES_LIST.URL}
                        method={APIConfig.SAMPLES_LIST.METHOD}
                        extraPayload={filterData}
                        isColumnFilterVisible={true}
                        onDataLoad={(data: any) => setData(data)}
                        moduleName={MODULE_NAME}
                    />
                </div>

                <DialogComponent open={showResultPdfPreviewDialog}
                                 maxWidth={'md'}
                                 title={'Sample Result Report'}
                                 isShowCancel={true}
                                 onClose={() => {
                                     setShowResultPdfPreviewDialog(false)
                                 }}
                                 className={"attachment-preview-dialog"}>
                    <div className="attachment-preview-dialog-body" id="file_preview_component">
                        <PdfPreviewComponent
                            attachmentFile={resultUploadPdf}
                            width="850"
                            height="450"
                            isFile={isNewResultPdf}
                        />
                    </div>
                    {resultUploadPdf && <div className="uploaded-attachment-file-name">
                        <span className="font-weight-bold"> Uploaded File Name:</span>
                        <span>{resultUploadPdf?.name}</span>
                    </div>
                    }
                    <div className="attachment-preview-dialog-footer">
                        <ButtonComponent variant={"outlined"}
                                         id="cancel_btn"
                                         fullWidth={true}
                                         color={"primary"}
                                         disabled={isResultPdfBeingUploaded}
                                         handleClick={() => {
                                             hiddenFileInput?.current?.click();
                                         }}
                        >
                            Re-upload
                        </ButtonComponent>&nbsp;
                        {
                            isContinueVisible &&
                            <ButtonComponent variant={"contained"}
                                             color={"primary"}
                                             id="continue_btn"
                                             fullWidth={true}
                                             isLoading={isResultPdfBeingUploaded}
                                             handleClick={onUploadResultPdf}>
                                Continue
                            </ButtonComponent>
                        }
                    </div>
                </DialogComponent>
                <input type={"file"}
                       className={"display-none"}
                       ref={hiddenFileInput}
                       accept={"application/pdf"}
                       onClick={(event: any) => {
                           event.target.value = null;
                       }}
                       onChange={(event) => {
                           handleResultPdfUpload(event);
                       }}
                />
            </>
        )
    }

;

export default SamplesListTableComponent;
